/**
 * Purchases section wrapper.
 */
import { SectionPage } from '@/components/layout/SectionPage';
import { PurchasesBuilder } from './PurchasesBuilder';

export function PurchasesPage() {
  return (
    <SectionPage
      basePath="/purchases"
      BuilderComponent={PurchasesBuilder}
      queryParamKeys={['preset', 'start']}
    />
  );
}
